import { ReachFeature } from './types';
export function getApiBaseUrl(): string {
  const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
  if (!baseUrl) throw new Error('API base URL not set');
  return baseUrl;
}

export function getExchangeUrl(): string {
  const base = getApiBaseUrl().replace(/\/$/, '');
  return `${base}/api/reach-hint-integration/exchange`;
}

export function getReachFeature(): ReachFeature {
  return import.meta.env.VITE_REACH_FEATURE ?? ReachFeature.ENGAGE;
}
